<template>
    <label
        class="form-group__label"
        v-click-outside="
            () => {
                isOpen = false;
            }
        "
        :class="labelClassArray">
        <div class="text_11 color-text_3" style="transform: translateY(5px) scale(0.84); transform-origin: left bottom">
            {{ label }}<span v-if="required" class="form-group__required">*</span>
        </div>
        <div
            class="select"
            ref="select"
            :class="{ 'select--open': isOpen, 'select--fixed-dd': fixedDropdown }"
            v-if="options">
            <div
                class="select__current text_13"
                :class="{ 'select__current--disabled': disabled }"
                @click="isOpen = !isOpen"
                v-html="currentValue ? currentLabel : options[Object.keys(options)[0]]"></div>
            <transition name="fade">
                <div
                    class="select__dropdown"
                    :class="longDropdown ? 'select__dropdown--long' : null"
                    v-if="isOpen && !disabled">
                    <div class="select__search" v-if="hasSearch">
                        <div class="form-group">
                            <Input
                                inputClass="text_11"
                                placeholder="поиск"
                                name="optionSearch"
                                :disabled="disabled"
                                v-model="optionQuery" />
                        </div>
                    </div>
                    <div
                        class="select__options"
                        :class="{ 'select__options--scrollable': hasScroll }"
                        v-if="filteredOptions && !longDropdown">
                        <perfect-scrollbar>
                            <div
                                class="select__option text_13"
                                @click="
                                    currentValue = optionValue;
                                    currentLabel = label;
                                    isOpen = false;
                                    $emit('change', optionValue);
                                "
                                :value="optionValue.toString()"
                                v-for="(label, optionValue, index) in filteredOptions"
                                :key="optionValue"
                                :selected="value ? optionValue == value : index == 0"
                                v-html="label"></div>
                        </perfect-scrollbar>
                    </div>
                    <div class="select__options-group" v-else-if="filteredOptions && longDropdown">
                        <div class="select__options" v-for="(optionsList, index) in filteredOptionsArray" :key="index">
                            <div
                                class="select__option text_13"
                                @click="
                                    currentValue = optionValue;
                                    currentLabel = label;
                                    isOpen = false;
                                    $emit('change', optionValue);
                                "
                                :value="optionValue.toString()"
                                v-for="(label, optionValue, index) in optionsList"
                                :key="optionValue"
                                :selected="value ? optionValue == value : index == 0"
                                v-html="label"></div>
                        </div>
                    </div>
                    <div class="select__option text_13" v-else>{{ $i18n.t("nothinf_found") }}</div>
                </div>
            </transition>
        </div>
    </label>
</template>
<script>
import Input from "~/components/form/Input";
export default {
    name: "Select",
    data() {
        return {
            currentValue: null,
            currentLabel: null,
            isOpen: false,
            optionQuery: "",
        };
    },
    components: { Input },
    computed: {
        labelClassArray() {
            return [this.labelClass, this.type == "checkbox" ? "form-group__label--checkbox" : ""];
        },
        filteredOptions() {
            if (this.optionQuery != "") {
                let list = {};
                for (const key in this.options) {
                    if (Object.hasOwnProperty.call(this.options, key)) {
                        const element = this.options[key];
                        if (element.toLowerCase().indexOf(this.optionQuery.toLowerCase()) + 1) {
                            list[key] = element;
                        }
                    }
                }
                if (Object.keys(list).length) {
                    return list;
                }
                return false;
            }
            return this.options;
        },
        filteredOptionsArray() {
            const keys = Object.keys(this.filteredOptions);
            const chunkSize = 10;
            const resultArray = [];

            for (let i = 0; i < keys.length; i += chunkSize) {
                const chunk = keys.slice(i, i + chunkSize);
                const obj = {};
                chunk.forEach((key) => {
                    obj[key] = this.filteredOptions[key];
                });
                resultArray.push(obj);
            }
            return resultArray;
        },
    },
    props: {
        fixedDropdown: {
            Boolean,
            default: false,
        },
        longDropdown: {
            type: Boolean,
            default: false,
        },
        maxOptionWidth: {
            type: Number,
            default: 0,
        },
        required: {
            type: Boolean,
            default: function () {
                return false;
            },
        },
        inputClass: {
            type: String,
        },
        labelClass: {
            type: String,
        },
        type: {
            type: String,
            default: function () {
                return "text";
            },
        },
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: function () {
                return "";
            },
        },
        options: {
            type: Object,
            required: true,
        },
        hasSearch: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: "",
        },
        hasScroll: {
            type: Boolean,
            default: false,
        },
        emintOnInit: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        value(val) {
            this.currentValue = val;
            this.currentLabel = this.options[val];
        },
        isOpen(val) {
            if (val) {
                if (!this.$device.isDesktop) {
                    try {
                        this.$refs.select.scrollIntoView({ block: "top", behavior: "smooth" });
                    } catch (err) {
                        console.log(err);
                    }
                }
            }
        },
        options: {
            deep: true,
            handler() {
                this.currentLabel = this.options[this.value];
            },
        },
    },
    mounted() {
        if (this.value) {
            this.currentValue = this.value;
            this.currentLabel = this.options[this.value];
            if (this.emintOnInit) {
                this.$emit("change", this.value);
            }
        } else {
            if (this.emintOnInit) {
                this.$emit("change", Object.keys(this.options)[0]);
            }
        }
        this.$emit("mounted", this.value ? this.value : Object.keys(this.options)[0]);
    },
};
</script>
<style lang="less">
.select {
    &__options .ps .ps__rail-y {
        right: 12px !important;
    }
    &__current > span {
        display: none;
    }
    &__option span {
        margin-left: 8px;
    }
}
</style>
<style lang="less" scoped>
.form-group {
    &__select {
        height: 30px;
        background: url(../../assets/icons/arrow-down.svg) center right no-repeat, transparent;
        border-bottom: 1px solid @border2;
        padding-right: 20px;
        option {
            line-height: 30px;
            font-size: 13px;
            font-family: @baseFont;
        }
    }
    &__label {
        .text_11 {
            white-space: nowrap;
        }
    }
}
.select {
    position: relative;
    &--open {
        z-index: 11;
    }
    &__current {
        padding-top: 7px;
        padding-bottom: 5px;
        border-bottom: 1px solid #000;
        padding-right: 20px;
        position: relative;
        cursor: pointer;
        white-space: nowrap;
        &:not(&--disabled) {
            &:after {
                content: "";
                position: absolute;
                width: 20px;
                background: url(../../assets/icons/arrow-down.svg) center right no-repeat, transparent;
                right: 0;
                top: 0;
                bottom: 4px;
                .trs(transform);
                .select--open & {
                    transform: scaleY(-1);
                }
            }
        }
    }
    &__dropdown {
        position: absolute;
        background: #fff;
        top: 100%;
        padding: 16px 0;
        border: 1px solid @border2;
        left: 0;
        margin-top: -1px;
        white-space: nowrap;
        .select--fixed-dd & {
            min-width: 100%;
            max-width: 250px;
            white-space: normal;
        }
        @media @sm {
            right: 0;
        }
        &--long {
            padding: 0;
            .select__options {
                max-height: 378px;
                .select__option:first-child {
                    margin-top: 16px;
                    @media @sm {
                        margin-top: 0;
                    }
                }
                .select__option:last-child {
                    margin-bottom: 16px;
                    @media @sm {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
    &__options {
        overflow: hidden;
        max-height: calc(34px * 6);
        background-color: #ffffff;
        display: flex;
        flex-direction: column;

        &--scrollable {
            overflow: auto;
        }
        .ps {
            height: 100%;
        }
        &-group {
            display: flex;
            gap: 2px;
            background-color: @border2;
            @media @sm {
                display: block;
                max-height: 132px;
                overflow-y: auto;
                padding: 14px 0;
                background-color: #ffffff;
            }
        }
    }
    &__option {
        padding: 8px 24px;
        cursor: pointer;
        &:hover {
            background: @bg;
        }
    }
    &__search {
        margin-left: 24px;
        margin-right: 24px;
        margin-top: -8px;
        margin-bottom: 8px;
    }
}
</style>
